import { createSlice } from "@reduxjs/toolkit"

import { CREDIT_AUTOMATION_SLICE_NAME } from "./creditAutomation.constants"
import {
  confirmCreditAutomationAccess,
  getCreditAutomation,
  requestCreditAutomation,
  turnOffCreditAutomation
} from "./creditAutomation.thunks"

const initialState = {
  fetching: false,
  status: null,
  activated_at: null,
  requested_at: null,
  can_request: false,
  is_eligible: false,
  processors: [],

  requestFetching: false,
  requestResult: null,

  confirmFetching: false,

  turnOffFetching: false
}

const slice = createSlice({
  name: CREDIT_AUTOMATION_SLICE_NAME,
  initialState,
  reducers: {
    creditAutomationRequestResultReset(state) {
      state.requestResult = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCreditAutomation.pending, (state) => {
        state.fetching = true
      })
      .addCase(getCreditAutomation.fulfilled, (state, action) => {
        state.fetching = false
        Object.assign(state, action.payload)
      })
      .addCase(getCreditAutomation.rejected, (state) => {
        state.fetching = false
      })

      .addCase(requestCreditAutomation.pending, (state) => {
        state.requestFetching = true
      })
      .addCase(requestCreditAutomation.fulfilled, (state, action) => {
        state.requestFetching = false
        if (action.payload.alreadyRequested) {
          state.requestResult = { alreadyRequested: true, detail: action.payload.detail }
        } else {
          Object.assign(state, action.payload.data)
          state.requestResult = { alreadyRequested: false }
        }
      })
      .addCase(requestCreditAutomation.rejected, (state) => {
        state.requestFetching = false
      })

      .addCase(confirmCreditAutomationAccess.pending, (state) => {
        state.confirmFetching = true
      })
      .addCase(confirmCreditAutomationAccess.fulfilled, (state) => {
        state.confirmFetching = false
      })
      .addCase(confirmCreditAutomationAccess.rejected, (state) => {
        state.confirmFetching = false
      })

      .addCase(turnOffCreditAutomation.pending, (state) => {
        state.turnOffFetching = true
      })
      .addCase(turnOffCreditAutomation.fulfilled, (state) => {
        state.turnOffFetching = false
      })
      .addCase(turnOffCreditAutomation.rejected, (state) => {
        state.turnOffFetching = false
      })
  }
})

export const creditAutomationActions = slice.actions
export const reducer = slice.reducer
